import groq from 'groq'

export default groq`
  *[_type == "ingredients"][0]{
    title,
    description,
    longDescription
  }
`
